import { CurrencyInput } from '@/components/CurrencyInput'
import {
  formatOperatingCostAmount,
  formatOperatingCostRate,
  parseOptionalRateInput,
} from '../lib/operating-costs'
import type { CreditInstallmentDraft } from '../lib/creditInstallmentDrafts'
import styles from '../CustosOperacionaisPage.module.css'

function draftTotalRate(draft: CreditInstallmentDraft): string {
  const rate = parseOptionalRateInput(draft.rate)
  const surcharge = parseOptionalRateInput(draft.surchargeRate)
  if (rate === null || surcharge === null) {
    return '—'
  }
  return formatOperatingCostRate(rate + surcharge)
}

type CreditInstallmentEditorProps = {
  drafts: CreditInstallmentDraft[]
  disabled: boolean
  idPrefix: string
  onChange: (drafts: CreditInstallmentDraft[]) => void
}

export function CreditInstallmentEditor({
  drafts,
  disabled,
  idPrefix,
  onChange,
}: CreditInstallmentEditorProps) {
  function updateDraft(installment: number, patch: Partial<CreditInstallmentDraft>) {
    onChange(
      drafts.map((draft) => (draft.installment === installment ? { ...draft, ...patch } : draft))
    )
  }

  return (
    <div className={styles.installmentList}>
      {drafts.map((draft) => (
        <div key={draft.installment} className={styles.installmentCard}>
          <p className={styles.installmentTitle}>{draft.installment}x</p>
          <label className={styles.field} htmlFor={`${idPrefix}-rate-${draft.installment}`}>
            Taxa (%)
            <input
              id={`${idPrefix}-rate-${draft.installment}`}
              className={styles.input}
              inputMode="decimal"
              value={draft.rate}
              disabled={disabled}
              onChange={(event) => updateDraft(draft.installment, { rate: event.target.value })}
            />
          </label>
          <label className={styles.field} htmlFor={`${idPrefix}-surcharge-rate-${draft.installment}`}>
            Acréscimo (%)
            <input
              id={`${idPrefix}-surcharge-rate-${draft.installment}`}
              className={styles.input}
              inputMode="decimal"
              value={draft.surchargeRate}
              disabled={disabled}
              onChange={(event) => updateDraft(draft.installment, { surchargeRate: event.target.value })}
            />
          </label>
          <label className={styles.field} htmlFor={`${idPrefix}-surcharge-amount-${draft.installment}`}>
            Acréscimo (R$)
            <CurrencyInput
              id={`${idPrefix}-surcharge-amount-${draft.installment}`}
              value={draft.surchargeAmount}
              disabled={disabled}
              onChange={(value) => updateDraft(draft.installment, { surchargeAmount: value })}
            />
          </label>
          <p className={styles.installmentTotal}>
            Total {draftTotalRate(draft)}
            {draft.surchargeAmount !== ''
              ? ` + ${formatOperatingCostAmount(Number(draft.surchargeAmount) || 0)}`
              : ''}
          </p>
        </div>
      ))}
    </div>
  )
}
